function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.488,
    xmlns: "http://www.w3.org/2000/svg",
    height: 19,
    id: "screenshot-16c21f02-c09f-80be-8007-7b7b1053b3a0",
    viewBox: "1008 14928 13.488 19",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b1053b3a0",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-11278-Layer_2",
    viewBox: "0 0 14.12 19.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-11278-Layer_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.37,
    x2: 7.37,
    y2: 11.34,
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11.94 7.84 7.4 11.81 2.19 7.81",
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1 13.99 1 18.89 13.12 18.89 13.12 13.99",
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-11278-Layer_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.37,
    x2: 7.37,
    y2: 11.34,
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11.94 7.84 7.4 11.81 2.19 7.81",
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1 13.99 1 18.89 13.12 18.89 13.12 13.99",
    style: {
      fill: "none",
      stroke: "#1b8eee",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b1055c338",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-16c21f02-c09f-80be-8007-7b7b1055c338"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 1008,
    y: 14928,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 13.488185017597289,
    height: 19,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b1055c339"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b1055c33a",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b10560aa8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-16c21f02-c09f-80be-8007-7b7b10560aa8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.0401611328125,14928L1015.0401611328125,14938.83203125",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-ebaa2bad-6d04-8053-8007-7c91c50914c4-16c21f02-c09f-80be-8007-7b7b10560aa8",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.0401611328125,14928L1015.0401611328125,14938.83203125",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 2,
      stroke: "#1b8eee",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b10566942"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-16c21f02-c09f-80be-8007-7b7b10566942"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.4056396484375,14935.4892578125L1015.06884765625,14939.28125L1010.0919189453125,14935.4599609375",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-ebaa2bad-6d04-8053-8007-7c91c5094aee-16c21f02-c09f-80be-8007-7b7b10566942",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.4056396484375,14935.4892578125L1015.06884765625,14939.28125L1010.0919189453125,14935.4599609375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 2,
      stroke: "#1b8eee",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-16c21f02-c09f-80be-8007-7b7b10566943"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-16c21f02-c09f-80be-8007-7b7b10566943"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.9552001953125,14941.3642578125L1008.9552001953125,14946.0439453125L1020.532958984375,14946.0439453125L1020.532958984375,14941.3642578125",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-ebaa2bad-6d04-8053-8007-7c91c5094aef-16c21f02-c09f-80be-8007-7b7b10566943",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.9552001953125,14941.3642578125L1008.9552001953125,14946.0439453125L1020.532958984375,14946.0439453125L1020.532958984375,14941.3642578125",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 2,
      stroke: "#1b8eee",
      strokeOpacity: 1
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4d4378137b9f07706ca7509ce5bf3cd3.svg";
export { ForwardRef as ReactComponent };